import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import MetadataFields from '../components/metadata-fields/metadata-fields';
import { getSubscriptionGroup, getSubscriptionGroups, createOrUpdateSubscriptionGroup, destroySubscriptionGroup } from '../api';
import { SET_SUBSCRIPTION_GROUP, SET_ERRORS, UPDATE_SUBSCRIPTION_GROUPS } from '../actions';
import {
  Button, TitleBar, Card, Table, CardHeader, ButtonGroup,
  SelectFieldWithLabel, TextFieldWithLabel, TextAreaWithLabel, Link,
  Layout, Alert, StatusMessage, NumberFieldWithLabel, CheckBox
} from '../components/library-components';
import validate from 'validate.js';
import _ from 'lodash-es';
import currencyUtils, { ALL_CURRENCIES } from '../helpers/currencyUtils';

const VISIBILITY = ['Public', 'Private'].map((k) => ({ label: k, value: k === 'Public' }));

export class CreateUpdateSubscriptionGroup extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      isAlertOpen: false,
      isSaveDisabled: true,
      campaignSubscriptionsEnabled: _.get(window.qtConfig, 'campaignSubscriptionsEnabled', false) === 'true',
      groupSubscriptionsEnabled: _.get(window.qtConfig, 'groupSubscriptionsEnabled', false) === 'true',
      showNotification: { isNotificationOpen: false, status: '', statusMessage: '' },
      assetCategories: null
    };
  }

  componentDidMount () {
    getSubscriptionGroup(this.props.subscriptionGroupId).then(group => {
      this.setState({ targetAmount: currencyUtils.convertToCurrencyUnits(group.target_amount), goal_amount_editable: group.goal_amount_editable });
      this.props.setSubscriptionGroup(group);
    });
    getSubscriptionGroups().then(plans => this.props.setSubscriptionGroups(plans));
  }

  updateField (field, value) {
    if (field === 'target_amount') {
      this.setState({ targetAmount: value });
      this.props.setSubscriptionGroup(Object.assign({}, this.props.subscriptionGroup, { [field]: currencyUtils.convertToLowestDenomination(value) }));
    } else {
      this.setState({ isSaveDisabled: false });
      this.props.setSubscriptionGroup(Object.assign({}, this.props.subscriptionGroup, { [field]: value }));
    }
  }

  subscriptionTypeOptions (type) {
    return ({ label: _.capitalize(type), value: type.split(' ').join('_') });
  }

  getSubscriptionTypeOptions () {
    const subscriptionTypes = ['standard'];

    if (this.state.campaignSubscriptionsEnabled) {
      subscriptionTypes.push('campaign');
    }
    if (this.state.groupSubscriptionsEnabled) {
      subscriptionTypes.push('group access');
    }
    return subscriptionTypes.map(x => this.subscriptionTypeOptions(x));
  }

  saveOrUpdateGroup (e) {
    e.preventDefault();
    var constraintsSubscriptionGroup = {
      name: { presence: true },
      description: { presence: true }
    };

    var errors = validate(this.props.subscriptionGroup, constraintsSubscriptionGroup);

    if (errors) {
      this.props.setErrors(errors);
    } else {
      createOrUpdateSubscriptionGroup(this.props.subscriptionGroup).then((response) => {
        window.location = '/subscription_groups/';
      }, errors => this.props.setErrors(errors.error));
    }
  }

  deleteGroup (e) {
    e.preventDefault();
    destroySubscriptionGroup(this.props.subscriptionGroupId)
      .then(() => { (window.location = '/subscription_groups'); });
  }

  openAlert () {
    this.setState({ isAlertOpen: true });
  }

  closeAlert () {
    this.setState({ isAlertOpen: false });
  }

  createNewPlan () {
    if (this.state.isSaveDisabled) {
      window.location = '/subscription_groups/' + this.props.subscriptionGroupId + '/subscription_plans/new';
    } else {
      this.setState({
        showNotification: {
          isNotificationOpen: true,
          status: 'error',
          statusMessage: 'Please save the data before creating a new plan'
        }
      });
    }
  }

  editLink (subscriptionPlan) {
    return (`/subscription_groups/${this.props.subscriptionGroupId}/subscription_plans/${subscriptionPlan.id}`);
  }

  getAllSubscriptionGroups () {
    const exceptCurrentGroup = _.filter(
      this.props.subscriptionGroups,
      (group) => group.id !== parseInt(this.props.subscriptionGroupId)
    );
    return _.map(exceptCurrentGroup, (group) => ({ name: group.name, id: group.id }));
  }

  render () {
    return (
      <Layout>
        {this.props.subscriptionGroupId === 'new' ? (
          <TitleBar
            title="Add Subscription Group"
            breadcrumbTitle="Subscription Group"
            breadcrumbPath="/subscription_groups"
          />
        ) : (
          <TitleBar
            title="Edit Subscription Group"
            buttonText="Subscriptions"
            button
            buttonUrl={`/analytics_subscriptions?subscription_group_id=${this.props.subscriptionGroupId}`}
            breadcrumbTitle="Subscription Group"
            breadcrumbPath="/subscription_groups"
          />
        )}

        <form>
          <Card title="Subscription Group Overview">
            <TextFieldWithLabel
              errors={_.get(this.props.errors, ['name', '0'])}
              label="Name"
              placeholder="Subscription Group Name"
              value={this.props.subscriptionGroup.name || ''}
              onChange={e => this.updateField('name', e.target.value)}
              id="subscription-group-name"
            />
            <TextAreaWithLabel
              errors={_.get(this.props.errors, ['description', '0'])}
              label="Description"
              placeholder="Description"
              rows="3"
              value={this.props.subscriptionGroup.description || ''}
              onChange={e => this.updateField('description', e.target.value)}
              id="subscription-group-description"
            />
            {this.props.subscriptionGroupId === 'new' &&
              <div className="form-row">
                <SelectFieldWithLabel
                  label="Group Type"
                  value={this.props.subscriptionGroup.subscription_type}
                  options={this.getSubscriptionTypeOptions()}
                  onChange={e => this.updateField('subscription_type', e.value)}
                  id="subscription-group-catgeory"
                  clearable={false}
                />
              </div>
            }

            {this.props.subscriptionGroup.subscription_type === 'campaign' &&
              <div className='text-and-select'>
                <NumberFieldWithLabel
                  label='Target Amount'
                  value={this.state.targetAmount}
                  onChange={(e) => this.updateField('target_amount', e.target.value)}
                  errors={_.get(this.props.errors, ['target_amount', '0']) || _.get(this.props.errors, ['target_amount', '0'])}
                  placeholder="Enter target amount"
                  dataTest='campaign-target-amount'
                  disabled={!this.state.goal_amount_editable}
                />
                <Select
                  className='select-currency'
                  value={this.props.subscriptionGroup.currency}
                  options={ALL_CURRENCIES}
                  onChange={(m) => m !== null ? this.updateField('currency', m.value) : null}
                  clearable={false}
                  searchable
                  arrowRenderer={currencyUtils.arrowRenderer}
                  autosize={false}
                  disabled={!this.state.goal_amount_editable}
                />
              </div>
            }
            {this.props.subscriptionGroup.subscription_type === 'campaign' &&
            <div className='form-row'>
              <CheckBox
                label="Stop subscriptions if target amount is reached"
                checked={_.get(this.props.subscriptionGroup, 'target_amount_validation_enabled', false)}
                value={_.get(this.props.subscriptionGroup, 'target_amount_validation_enabled', false)}
                onChange={(e) => this.updateField('target_amount_validation_enabled', !!e.target.checked)}
                errors={_.get(this.state.errors, ['target_amount_validation_enabled', '0'])}
              />
            </div>
            }
            <div className="form-row">
              <SelectFieldWithLabel
                label="Visibility"
                value={this.props.subscriptionGroup.public}
                options={VISIBILITY}
                onChange={e => this.updateField('public', e.value)}
                id="subscription-group-public"
                clearable={false}
              />
            </div>

            <MetadataFields
              metadata_fields={
                this.props.subscriptionGroup.metadata_fields || []
              }
              onChange={metadataFields =>
                this.updateField('metadata_fields', metadataFields)
              }
            />
          </Card>

          {this.props.subscriptionGroupId !== 'new' && (
            <Card>
              <CardHeader
                dataTest="add_plan"
                title="Subscription Plans"
                buttonText="Add Plan"
                buttonOnClick={() => this.createNewPlan()}
                isButton={this.props.subscriptionGroupId !== 'new'}
              />

              {this.props.subscriptionGroup.subscription_plans && (
                <Table
                  header={['Name', 'Duration', 'Price', '']}
                  className="table-default--4cols"
                >
                  {this.props.subscriptionGroup.subscription_plans.map(
                    (subscriptionPlan, index) => (
                      <div className="table-default__row" key={index}>
                        <div className="table-default__cell">
                          {subscriptionPlan.title}
                        </div>
                        <div className="table-default__cell">
                          {subscriptionPlan.duration_length}{' '}
                          {subscriptionPlan.duration_unit}
                        </div>
                        <div className="table-default__cell">
                          {subscriptionPlan.price_currency}
                          {currencyUtils.convertToCurrencyUnits(
                            subscriptionPlan.price_cents
                          )}
                        </div>
                        <div className="table-default__cell">
                          <Link url={this.editLink(subscriptionPlan)}>
                            Edit
                          </Link>
                        </div>
                      </div>
                    )
                  )}
                </Table>
              )}
            </Card>
          )}

          <ButtonGroup
            columns={this.props.subscriptionGroupId !== 'new' ? 'two' : ''}
          >
            {this.props.subscriptionGroupId !== 'new' && (
              <Button
                dataTest="delete_subscription_group"
                onClick={e => this.openAlert(e)}
                destructive
              >
                Delete Group
              </Button>
            )}
            <Button
              dataTest="save_subscription_group"
              disabled={this.state.isSaveDisabled}
              onClick={e => this.saveOrUpdateGroup(e)}
              primary
            >
              Save
            </Button>
          </ButtonGroup>

          <Alert
            title="Delete Subscription Group"
            open={this.state.isAlertOpen}
            destructive
            onCancel={() => this.closeAlert()}
            onConfirm={e => this.deleteGroup(e)}
          >
            Deleted data cannot be recovered. Do you still want to continue?
          </Alert>

          {this.state.showNotification.isNotificationOpen && (
            <StatusMessage
              statusMessage={this.state.showNotification.statusMessage}
              status={this.state.showNotification.status}
              onCancel={() => {
                this.setState({
                  showNotification: {
                    isNotificationOpen: false,
                    status: '',
                    statusMessage: ''
                  }
                });
              }}
            />
          )}
        </form>
      </Layout>
    );
  }
}

function mapStateToProps (state) {
  return {
    subscriptionGroup: state.subscriptionGroup || {},
    errors: state.errors || [],
    subscriptionGroups: state.subscriptionGroups || []
  };
}

function mapDispatchToProps (dispatch) {
  return {
    setSubscriptionGroup: (plan) => dispatch({ type: SET_SUBSCRIPTION_GROUP, subscriptionGroup: plan }),
    setErrors: (errors) => dispatch({ type: SET_ERRORS, errors: errors }),
    setSubscriptionGroups: (plans) => dispatch({ type: UPDATE_SUBSCRIPTION_GROUPS, subscriptionGroups: plans })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateUpdateSubscriptionGroup);
